import { Stack, StackProps } from '@mui/material'

import { layout } from 'src/theme/tokens.generated'

// ----------------------------------------------------------------------
// The ways to sign in, one above another: Continue with Tesla, Google,
// Apple. One choice with several answers, so one group at one rhythm.
//
// An entry screen spaces its blocks 24 apart: the heading, an error, the
// choice, the form. Dropped straight into that stack, three buttons took the
// same 24 from each other and read as three separate blocks. Wrap them and
// leave the screen's stack alone: the group keeps its distance from the
// blocks around it, and the buttons keep `signInOptionGap` from each other.
//
// The sign-in page and an invitation draw the same run, so the distance is
// stated here once rather than on each screen.
// ----------------------------------------------------------------------

export default function SignInOptions({ children, sx, ...other }: StackProps) {
  return (
    <Stack
      data-sign-in-options=""
      {...other}
      sx={[
        { gap: `${layout.signInOptionGap}px` },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Stack>
  )
}
